import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const IpodDockIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "IpodDockIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M13.3101 3.97554H12.4893C12.2159 3.97554 11.9932 4.19759 11.9932 4.47098C11.9932 4.74437 12.2159 4.96709 12.4893 4.96709H13.3101C13.5835 4.96709 13.8059 4.74438 13.8059 4.47098C13.8059 4.19758 13.5835 3.97554 13.3101 3.97554Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.6463 13.827H17.9108V4.06089C17.9108 3.10802 17.1359 2.33319 16.1834 2.33319H9.61565C8.66345 2.33319 7.88861 3.10802 7.88861 4.06089V13.827H7.15279C4.84263 13.827 2.96289 15.7067 2.96289 18.0166C2.96289 20.3271 4.84263 22.2068 7.15279 22.2068H18.6463C20.9568 22.2068 22.8365 20.3271 22.8365 18.0166C22.8365 15.7067 20.9568 13.827 18.6463 13.827ZM8.88016 4.06089C8.88016 3.65547 9.21023 3.3254 9.61565 3.3254H16.1834C16.5888 3.3254 16.9189 3.65547 16.9189 4.06089V13.827H8.88016V4.06089ZM21.8446 18.0166C21.8446 19.7803 20.41 21.2153 18.6463 21.2153H7.15279C5.38908 21.2153 3.95444 19.7803 3.95444 18.0166C3.95444 16.2529 5.38908 14.8185 7.15279 14.8185H18.6463C20.41 14.8185 21.8446 16.2529 21.8446 18.0166Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.15279 15.4687C5.74782 15.4687 4.60491 16.6116 4.60491 18.0166C4.60491 19.4215 5.74782 20.5651 7.15279 20.5651C8.55776 20.5651 9.701 19.4215 9.701 18.0166C9.701 16.6116 8.55775 15.4687 7.15279 15.4687ZM8.70946 18.0166C8.70946 18.8754 8.01098 19.5736 7.15279 19.5736C6.2946 19.5736 5.59646 18.8754 5.59646 18.0166C5.59646 17.1584 6.29461 16.4602 7.15279 16.4602C8.01097 16.4602 8.70946 17.1584 8.70946 18.0166Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M18.6463 15.4687C17.2413 15.4687 16.0981 16.6116 16.0981 18.0166C16.0981 19.4215 17.2413 20.5651 18.6463 20.5651C20.0512 20.5651 21.1945 19.4215 21.1945 18.0166C21.1945 16.6116 20.0512 15.4687 18.6463 15.4687ZM20.2029 18.0166C20.2029 18.8754 19.5045 19.5736 18.6463 19.5736C17.7881 19.5736 17.0896 18.8754 17.0896 18.0166C17.0896 17.1584 17.7881 16.4602 18.6463 16.4602C19.5045 16.4602 20.2029 17.1584 20.2029 18.0166Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.6681 18.7527H10.8473C10.5739 18.7527 10.3515 18.9748 10.3515 19.2482C10.3515 19.5216 10.5739 19.7443 10.8473 19.7443H11.6681C11.9415 19.7443 12.1639 19.5216 12.1639 19.2482C12.1639 18.9748 11.9415 18.7527 11.6681 18.7527Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.9518 18.7527H14.131C13.8576 18.7527 13.6352 18.9748 13.6352 19.2482C13.6352 19.5216 13.8576 19.7443 14.131 19.7443H14.9518C15.2252 19.7443 15.4479 19.5216 15.4479 19.2482C15.4479 18.9748 15.2252 18.7527 14.9518 18.7527Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M11.2577 15.4687C10.7579 15.4687 10.3515 15.8754 10.3515 16.3749C10.3515 16.8743 10.7579 17.2811 11.2577 17.2811C11.7574 17.2811 12.1639 16.8743 12.1639 16.3749C12.1639 15.8754 11.7574 15.4687 11.2577 15.4687Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M14.5414 15.4687C14.0416 15.4687 13.6352 15.8754 13.6352 16.3749C13.6352 16.8743 14.0416 17.2811 14.5414 17.2811C15.0412 17.2811 15.4479 16.8743 15.4479 16.3749C15.4479 15.8754 15.0412 15.4687 14.5414 15.4687Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default IpodDockIcon;
